

export default {
    brand:[],
    related:[],
    product:[],
    group:[],
    category:[],
    imagen:'',
	error: false,
    errorMessage: '',
	productsForm:[],
	params: {
        price_list_id:0,
    }
}



// WEBPACK FOOTER //
// ./src/b2b/modules/relative-products-form/state.js